import Review from './Review';
import { selectAllStrings } from '../language/languageSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useState } from 'react';
import ReviewModal from './ReviewModal';
import AskModal from '../../app/AskModal';
import { deleteReview, editedReview } from '../reviews/reviewsSlice';
import { fetchDevices } from '../user/userSlice';
import { useEffect } from 'react';
import { getCardStatus } from '../../api/mobile';

const ReviewList = ({reviewIds, reviewsStatus, reviewsLimit, reviewsError, 
    selectById, showLink = false, showDate = true, showControls = false, forceShowControls = false}) => {
    const strings = useSelector(selectAllStrings);
    const [reviewEdited, setReviewEdited] = useState(null);
    
    const [showAskModal, setShowAskModal] = useState(false);
    const [showReviewModal, setShowReviewModal] = useState(false);
    const [askProps, setAskProps] = useState(null);
    const devicesStatus = useSelector(state => state.user.devices.status);
    const dispatch = useDispatch();
    
    useEffect(async () => {
        if(devicesStatus == 'idle') {
            let cardStatus = await getCardStatus();
            dispatch(fetchDevices(cardStatus.cardNumber));
        }
    }, [devicesStatus]);
    
    const editReview = (event, review) => {
        event.preventDefault();
        setReviewEdited(review);
        dispatch(editedReview(review));
        setShowReviewModal(true);
    }
    const onDeleteReview = (event, reviewId) => {
        event.preventDefault();
        setAskProps({
            question: strings.sure_delete_review,
            onConfirm: () => {
                dispatch(deleteReview(reviewId));
                setAskProps(null);
            }
        });
    };
    
    
    
    
    
    return <div><div className="review-list">
        {reviewsStatus === 'loading' ? <div className="loader"></div> : reviewsStatus === 'succeeded' ?
                        reviewIds.slice(0, reviewsLimit).map((reviewId) =>
                <Review key={reviewId} reviewId={reviewId} selector={selectById} showLink={showLink} showDate={showDate} showControls={showControls}
                onEdit={editReview} onDelete={onDeleteReview} forceShowControls={forceShowControls}
                />)
                        : <div>{reviewsError}</div>}
    </div>
    {askProps ? <AskModal message={askProps.question} onConfirm={askProps.onConfirm} onCancel={() => setAskProps(null)} /> : null}
    {showReviewModal ? <ReviewModal onGoBack={() => setShowReviewModal(false)} poiId={reviewEdited.poi_id} 
                                        defaultRating={reviewEdited.eval} defaultReview={reviewEdited.review} 
                                        reviewId={reviewEdited.re_id}
                                        /> : null}
    </div>
};

export default ReviewList;